import {ValidationResult} from "./validation-result"

export function validateRequiredField(value: string): ValidationResult {
  const valid = value != null && value.length > 0

  return {
    valid,
    errorMessage: valid ? "" : "Dit is een verplicht veld"
  }
}